// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"CheckDetails_detailsContainer__2GOY_","tabsContainer":"CheckDetails_tabsContainer__2av5N","ulStyle":"CheckDetails_ulStyle__LeBEA"};